import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';

import { DialogRef } from '../../services/modal.service';
import { ModalService } from '../../services/modal.service';

import { I18nInfo } from '../../models/i18n.model';
import { Country, Language } from '../../models/lists.model';
import { CapitalizePipe } from '../../pipes/capitalize.pipe';
import { I18nService } from '../../services/i18n.service';
import { ListsService } from '../../services/lists.service';

import { showErrorMessage } from '../../utils/utils';
import { TranslatePipe, TranslateWithPunctuationPipe } from '../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export class LanguageSelectorDialogContext {
  showClose: boolean;
  isBlocking: boolean;
  size: string;
}

@Component({
  standalone: true,
  selector: 'language-selector-dlg',
  templateUrl: 'language-selector-dialog.component.html',
  imports: [CapitalizePipe, TranslatePipe, TranslateWithPunctuationPipe, CommonModule, FormsModule],
})
export class LanguageSelectorDialogComponent implements OnInit {
  context: LanguageSelectorDialogContext;
  i18nInfo: I18nInfo;

  organisationCountry: Country;

  languagesIndex: Map<number, Language>;

  constructor(
    public dialog: DialogRef<LanguageSelectorDialogContext>,
    private i18nService: I18nService,
    private listService: ListsService,
    private modal: ModalService,
  ) {
    this.context = dialog.context;
  }

  private createI18nInfo() {
    this.i18nInfo = new I18nInfo();
    const iorigin = this.i18nService.i18nInfo;
    // pas édité : copie référence OK
    this.i18nInfo.country = iorigin.country;

    this.i18nInfo.languageGui = new Language();
    this.i18nInfo.languageGui.id = iorigin.languageGui.id;
    this.i18nInfo.languageGui.code = iorigin.languageGui.code;
    this.i18nInfo.languageGui.label = iorigin.languageGui.label;
    this.i18nInfo.languageGuiOrganisationDefault = iorigin.languageGuiOrganisationDefault;

    this.i18nInfo.languagePdf = new Language();
    this.i18nInfo.languagePdf.id = iorigin.languagePdf.id;
    this.i18nInfo.languagePdf.code = iorigin.languagePdf.code;
    this.i18nInfo.languagePdf.label = iorigin.languagePdf.label;
    this.i18nInfo.languagePdfOrganisationDefault = iorigin.languagePdfOrganisationDefault;
  }

  private commitI18nInfo() {
    const iorigin = this.i18nService.i18nInfo;

    iorigin.languageGui.id = this.i18nInfo.languageGui.id;
    iorigin.languageGui.code = this.i18nInfo.languageGui.code;
    iorigin.languageGui.label = this.i18nInfo.languageGui.label;
    iorigin.languageGuiOrganisationDefault = this.i18nInfo.languageGuiOrganisationDefault;

    iorigin.languagePdf.id = this.i18nInfo.languagePdf.id;
    iorigin.languagePdf.code = this.i18nInfo.languagePdf.code;
    iorigin.languagePdf.label = this.i18nInfo.languagePdf.label;
    iorigin.languagePdfOrganisationDefault = this.i18nInfo.languagePdfOrganisationDefault;
  }

  ngOnInit() {
    this.createI18nInfo();

    const obs1 = this.listService.getCountries(true);
    const obs2 = this.listService.getLanguages();
    forkJoin([obs1, obs2]).subscribe((data: Array<any>) => {
      this.handleCountries(data[0]);
      this.handleLanguages(data[1]);

      const c = this.organisationCountry;
      c.languagesGui = c.languagesGui.sort((a: any, b: any) =>
        this.languagesIndex.get(a['id']).label.localeCompare(this.languagesIndex.get(b['id']).label),
      );
      c.languagesPdf = c.languagesPdf.sort((a: any, b: any) =>
        this.languagesIndex.get(a['id']).label.localeCompare(this.languagesIndex.get(b['id']).label),
      );
    });
  }

  handleCountries(countries: Country[]) {
    for (const country of countries) {
      if (country.id == this.i18nInfo.country.id) {
        this.organisationCountry = country;
        break;
      }
    }
  }

  handleLanguages(languages: Language[]) {
    this.languagesIndex = new Map<number, Language>();
    for (const language of languages) {
      this.languagesIndex.set(language.id, language);
    }
  }

  save() {
    this.i18nService.save(this.i18nInfo).subscribe(
      (data: any) => {
        window.location.reload();
      },
      (error) => {
        this.handleSaveError(error);
      },
    );
  }

  handleSaveError(error: any) {
    // FIXME détailler les erreurs du formulaire
    // FIXME définir un format pour les erreurs de validation
    console.error(error);
    showErrorMessage(this.modal, 'Il y a des erreurs dans le formulaire');
  }

  onEditLanguageGui() {
    this.i18nInfo.languageGuiOrganisationDefault = false;
    return true;
  }

  onEditLanguagePdf() {
    this.i18nInfo.languagePdfOrganisationDefault = false;
    return true;
  }

  findIndex(index: any, itemId: any) {
    itemId = +itemId;
    return index.get(itemId);
  }

  dismiss() {
    this.dialog.close();
  }

  beforeDismiss(): boolean {
    return true;
  }

  beforeClose(): boolean {
    return false;
  }
}
